/**
 * Shared utility for resolving API URL with proper fallback and protocol handling
 * 
 * This ensures consistent API URL resolution across the application:
 * - Handles missing environment variables
 * - Adds protocol if missing
 * - Provides sensible defaults for development and production
 */
export function getApiUrl(): string {
  const envUrl = process.env.NEXT_PUBLIC_API_URL || process.env.NEXT_PUBLIC_API_URL;
  
  // If no env var is set, use development default
  if (!envUrl) {
    return process.env.NODE_ENV === 'production' 
      ? 'https://api.neurocluster.dev'
      : 'http://localhost:8000';
  }
  
  // If URL doesn't start with http:// or https://, add https://
  if (!envUrl.startsWith('http://') && !envUrl.startsWith('https://')) {
    return `https://${envUrl}`;
  }
  
  return envUrl;
}

/**
 * Cached API URL - call getApiUrl() to get the resolved URL
 */
export const API_URL = getApiUrl();

